import 'core-js/stable'
import 'dayjs/locale/en'
import 'dayjs/locale/es'
import 'dayjs/locale/pt-br'
import 'regenerator-runtime/runtime'
import '@winnin/ds-tokens/styles.css'
import '@winnin/ds-core/styles.css'
import '@winnin/ds-charts/styles.css'
import '@winnin/ds-date-range-picker/styles.css'
import '@winnin/ds-file-dropzone/styles.css'
import './lib/highcharts-init'

import { StrictMode, Suspense } from 'react'
import { createBrowserHistory } from 'history'
import { Provider } from 'mobx-react'
import { RouterStore, syncHistoryWithStore } from 'mobx-react-router'
import { render } from 'react-dom'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import { Router } from 'react-router-dom'
import { RecoilRoot } from 'recoil'
import { WinninProvider } from '@winnin/ds-core'
import { Loading } from '@winnin/winnin_ui.components.loading'
import { ThemeProvider } from '@winnin/winnin_ui.theme.theme-provider'

import { customerioTracker } from 'lib'
import { I18nProvider } from 'lib/tolgee'
import * as stores from 'stores'
import FeatureFlagsStore from 'stores/feature-flags'
import { analyticsTracker, datadog } from 'utils'
import getEnvFromLocation from 'utils/getEnvFromLocation'

import ApolloProvider from './ApolloProvider'
import App from './App'
import { AuthWrapper } from './AuthWrapper'
import RouteChangeMiddleware from './components/RouteChangeMiddleware'

import './index.scss'

// Uncomment to get LCP insights on the console:
// import './lcpPerformance'

const BUILD_ENV_SHORT = {
  production: 'PROD',
  development: 'DEV',
  staging: 'STG',
  local: 'LOC',
  test: 'TEST',
}

const appEnv = getEnvFromLocation()
const browserHistory = createBrowserHistory()
const routingStore = new RouterStore()

const history = syncHistoryWithStore(browserHistory, routingStore)
global.BUILD_ENV = appEnv

stores.QueryStringStore.setStore(routingStore)
stores.VideoModalStore.setRoutingStore(routingStore)

customerioTracker.init()
analyticsTracker.start()
datadog.init()
FeatureFlagsStore.init()

render(
  <StrictMode>
    <Suspense fallback={<Loading />}>
      <Router history={history}>
        <HelmetProvider>
          <ApolloProvider>
            <Helmet
              titleTemplate={`${appEnv !== 'production' ? BUILD_ENV_SHORT[appEnv] + ' · ' : ''}%s · Winnin Intelligence`}
            />
            <Provider {...stores} routingStore={routingStore}>
              <RouteChangeMiddleware>
                <ThemeProvider>
                  <I18nProvider filesUrlPrefix="/i18n/" loadingFallback={<Loading />}>
                    <RecoilRoot>
                      <AuthWrapper>
                        <WinninProvider>
                          <App />
                        </WinninProvider>
                      </AuthWrapper>
                    </RecoilRoot>
                  </I18nProvider>
                </ThemeProvider>
              </RouteChangeMiddleware>
            </Provider>
          </ApolloProvider>
        </HelmetProvider>
      </Router>
    </Suspense>
  </StrictMode>,
  document.getElementById('root')
)
